import Vue from "vue";
import Router from "vue-router";
import RouterList from "./router";
import VueCookie from "vue-cookie";
import store from "@/store";
import { base64 } from "../utils/index";
import { Message } from "element-ui";

Vue.use(Router);
//store.dispatch('jfdepositPage');

// if (store.state.isNewDeposit) {
//   for (let i = 0; i < RouterList.length; i++) {
//     const item = RouterList[i];
//     if (item.meta.title == '资金管理') {
//       for (let j = 0; j < item.children.length;) {
//         const citem = item.children[j];
//         if (citem.meta.type == 'deposit') {
//           item.children.splice(j, 1);
//         } else {
//           j++;
//         }
//       }
//       item.children.splice(0, 1, { path: '/deposit', name: 'deposit', meta: { title: '存款' }, component: resolve => { require(['@/views/fund/cashRegister.vue'], resolve) } })
//       item.children.push({ path: '/cashRegisterAlipay', name: 'cashRegisterAlipay', meta: { title: '存款', hide: true }, component: resolve => { require(['@/views/fund/cashRegisterAlipay.vue'], resolve) } })
//       item.children.push({ path: '/cashRegisterBank', name: 'cashRegisterBank', meta: { title: '存款', hide: true }, component: resolve => { require(['@/views/fund/cashRegisterBank.vue'], resolve) } })
//       item.children.push({ path: '/cashRegisterStep', name: 'cashRegisterStep', meta: { title: '存款', hide: true }, component: resolve => { require(['@/views/fund/cashRegisterStep.vue'], resolve) } })
//       item.children.push({ path: '/bankremittance', name: 'bankremittance', meta: { title: '银行汇款', hide: true }, component: resolve => { require(['@/views/fund/bankremittance.vue'], resolve) } })
//       break;
//     }
//   }
// }

const router = new Router({
  // mode: 'history',
  routes: RouterList
});

//路由器跳转前置操作
router.beforeEach((to, from, next) => {
  toPath = to.fullPath;
  fromPath = from.fullPath;

  if (to.query.returnUrl) {
    location.href = to.query.returnUrl;
  }

  //deposit antbag recharge bankremittance  transferPayment lightningPayment
  // if(to.name=='deposit'||to.name=='antbag'||to.name=='recharge'||to.name=='bankremittance'||to.name=='transferPayment'||to.name=='lightningPayment'){
  //   if(!(store.state.userInfo.role==4||store.state.userInfo.role==5)){
  //     Message({
  //       message:"暂无可用通道，请联系客服处理。",
  //       type: 'warning'
  //     });
  //     return
  //   }
  // }
  // 资金管理权限
  // if (to.meta.pathWay) {
  //   let fundsPage = to.meta.pathWay.split('-')[0]
  //   if (fundsPage == 4 && store.state.listType == 1) {
  //     store.dispatch('fundsStatus', to.meta.title)
  //   }
  // }

  //window.document.title = to.meta.title
  window.scrollTo(0, 0);

  let auth = to.meta.auth;
  let userInfo = localStorage.getItem("I")
    ? JSON.parse(base64.decode(localStorage.getItem("I")))
    : "";
  // let userInfo = userInfo2.jfAccount || userInfo2.jfSimulatorAccount

  if (!VueCookie.get("remember") && to.path != "/login") {
    // Message.error('登录过期，请重新登录')
    if (
      store.state.userRole == 4 ||
      store.state.userRole == 5 ||
      /www.jf24k/.test(window.location.origin)
    ) {
      let clientid = localStorage.getItem("clientid");
      localStorage.clear();
      localStorage.setItem("clientid", clientid);
      window.location.href = "/login/index.html";
    } else {
      let clientid = localStorage.getItem("clientid");
      localStorage.clear();
      localStorage.setItem("clientid", clientid);
      window.location.href = "/login/index.html";
      // next({
      //   path: '/login',
      //   replace: true
      // })
    }

    return;
  } else if (
    (from.name == "Login" && userInfo.type) ||
    to.name == "error-403" ||
    to.name == "error-404" ||
    to.name == "error-500"
  ) {
    next();
  } else if (typeof userInfo.type === "undefined" && to.path != "/login") {
    // Message.error('登录过期，请重新登录')
    if (
      store.state.userRole == 4 ||
      store.state.userRole == 5 ||
      /www.jf24k/.test(window.location.origin)
    ) {
      window.location.href = "/login/index.html";
    } else {
      window.location.href = "/login/index.html";
      // next({
      //   path: '/login',
      //   replace: true
      // })
    }
  } else if (typeof userInfo.type != "undefined" && to.path == "/login") {
    next({
      path: "/home",
      replace: true
    });
  } else if (
    typeof userInfo.type != "undefined" &&
    store.state.accountType == "0" &&
    !auth &&
    to.meta.title != "首页"
  ) {
    next({
      path: "/403",
      replace: true
    });
  } else {
    next();
  }
  maidian({ eventname: "z1", eventdescribe: "访客数据", eventtype: "visit" });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js